import { createGlobalStyle } from 'styled-components'

const PromoDetailsNewGlobalStyles = createGlobalStyle`
  #promo-container {
    width: 100%;
  }

  #promo-container .promo-details-new__content {
    width: 100%;
    max-width: 720px;
  }

  #promo-container #bodyTable,
  #promo-container #emailContainer {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 auto !important;
  }

  #promo-container table {
    display: table !important;
    width: 100% !important;
    max-width: 720px !important;
    margin: 0 auto !important;
    font-family: 'Nunito Sans', sans-serif;
    border-spacing: 0;
    border-collapse: collapse;
  }

  #promo-container tr {
    display: table-row !important;
  }

  #promo-container td,
  #promo-container th {
    padding: 8px;
    font-size: 16px;
    vertical-align: top;
  }

  #promo-container td[style*='text-align:center'],
  #promo-container th[style*='text-align:center'] {
    text-align: center !important;
  }

  #promo-container td[align='left'],
  #promo-container th[align='left'] {
    text-align: left !important;
  }

  #promo-container td[align='right'],
  #promo-container th[align='right'] {
    text-align: right !important;
  }

  #promo-container td[style*='text-align:center'] a {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    margin: 0 8px;
  }

  #promo-container p {
    margin-top: 0;
    margin-bottom: 16px;
    line-height: 1.5;
    font-size: 16px;
  }

  #promo-container h1,
  #promo-container h2,
  #promo-container h3,
  #promo-container h4,
  #promo-container h5,
  #promo-container h6 {
    margin: 0 0 16px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    line-height: 1.2;
  }

  #promo-container ul,
  #promo-container ol {
    margin: 0 0 16px;
    padding-left: 20px;
  }

  #promo-container li {
    margin-bottom: 8px;
  }

  #promo-container img {
    max-width: 100%;
    height: auto;
  }

  #promo-container .captionImage {
    width: 100% !important;
    max-width: 720px !important;
    height: auto !important;
    object-fit: contain;
  }

  #promo-container table.tracklist {
    max-width: 672px !important;
  }

  #promo-container table.tracklist td,
  #promo-container table.tracklist th {
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: middle;
  }

  #promo-container table.tracklist td[width],
  #promo-container table.tracklist th[width] {
    padding-left: 0;
    padding-right: 0;
    white-space: nowrap;
  }

  #promo-container hr {
    border: 0;
    height: 1px;
    margin: 16px 0;
  }
`

export default PromoDetailsNewGlobalStyles
